import React from 'react'
import cx from 'classnames'
import PropType from 'prop-types'

import { SvgIcon } from '../svg-icon'

import styles from './locations-position-icon.module.css'

const shadowPath = 'M24,44.2c-2.4,0-4.4-1-4.4-2.2s2-2.2,4.4-2.2,4.4,1,4.4,2.2S26.4,44.2,24,44.2Z'
const locationsPath = 'M21.4,15V30H19.2V15a1.19,1.19,0,0,1,1.2-1A1.07,1.07,0,0,1,21.4,15Zm.8.5v8.7l8.6-4.3Z'
const backgroundPath = `M34.8,10.8a15.27,15.27,0,0,0-21.5-.2l-.2.2a15.27,15.27,0,0,0-.2,21.5l.2.2c2.9,2.7,10.9,9,10.9,
9s8-6.3,10.8-9.1A15.27,15.27,0,0,0,35,10.9C34.9,10.9,34.9,10.8,34.8,10.8Z`

const propTypes = {
    backgroundStyle: PropType.objectOf(PropType.string),
    locationsClassName: PropType.string,
    shadowClassName: PropType.string
}

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48,
    width: 36
}

/**
 * Stateless function representing a location pin icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @param {Object} [props.locationsClassName] The class name for the location icon
 * @param {Object} [props.backgroundStyle] The style object for the background svg path
 * @param {Object} [props.shadowClassName] The class name for the shadow
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <LocationsPositionIcon width={12} />
 */
const LocationsPositionIcon = function (props) {
    const combinedClassnames = cx(props.className, styles['location-pin'])

    return (
        <SvgIcon {...props} className={combinedClassnames}>
            <path className={cx(styles['location-pin-shadow'], props.shadowClassName)} d={shadowPath} />

            <path className={cx(styles['location-pin-background'])} style={props.backgroundStyle} d={backgroundPath} />
            <path d={locationsPath} className={cx(styles['location-pin-default'], props.locationsClassName)} />
        </SvgIcon>
    )
}

LocationsPositionIcon.defaultProps = defaultProps
LocationsPositionIcon.propTypes = propTypes

export { LocationsPositionIcon }
